import { useDispatch, useSelector } from "react-redux";
import {
  LOCATION,
  MASTERGROUP,
  OPERATION,
} from "../store/businesslogic/hardwiredlogic";
import {
  currentNodeChangedOnDirectClick,
  getFormText,
  getFormType,
  getGroupsOrder,
  getNonPriorityGroups,
  getIsFormAnyPriority
} from "../store/qf";
import FormNavHeader from "./FormNavHeader";
import _ from "lodash";
import FormSubGroupsNav from "./FormSubGroupsNav";
import { useEffect, useState } from "react";

const decideIfFormIsExpandable = ({ formtype, groupsorder }) => {
  if (formtype === MASTERGROUP || formtype === OPERATION) {
    if (!_.isEmpty(groupsorder)) {
      if (groupsorder.length <= 1) {
        return false;
      }
    } else return false;
  }

  if (formtype === LOCATION) {
    return true;
  }

  return true;
};
const FormHeaderAndSubGroups = ({ formid, currentnode }) => {
  const [open, setOpen] = useState(true);
  const [expressDisplay, setExpressDisplay] = useState('flex')
  const text = useSelector(getFormText(formid));
  const formtype = useSelector(getFormType(formid));
  const groupsorder = useSelector(getGroupsOrder(formid));
  const nonPriorityGroups = useSelector(getNonPriorityGroups)
  const isFormAnyPriority = useSelector(getIsFormAnyPriority({formid}))

  const isopen = currentnode?.formid === formid;

  const isFormExpandable = decideIfFormIsExpandable({
    formtype,
    groupsorder,
  });

  const dispatch = useDispatch();

  const handleOnHeaderClick = () => {
    //change node to form's current node
    dispatch(currentNodeChangedOnDirectClick(formid));
    setOpen(!open);
  };

  useEffect(() => {
    setOpen(true);
  }, [isopen]);

  // useEffect(() => {
  //   // if all groups in header are hidden we are gonna hide this header
  //   //console.log(nonPriorityGroups)
  //   //console.log(groupsorder)
  //   let hideHeaderGroup = groupsorder?.every(v => nonPriorityGroups?.includes(v))
  //   //console.log("Hide " , text, " ", hideHeaderGroup)
  //   if(hideHeaderGroup){
  //     setExpressDisplay("none")
  //   }
  //   else{
  //     setExpressDisplay("flex")
  //   }
  // }, [nonPriorityGroups, groupsorder]);

  const subGroupOpen = ({ formtype }) => {
    if (formtype === MASTERGROUP || formtype === OPERATION) {
      if (isFormExpandable) {
        if (isopen && open) {
          return true;
        }
      }
    }

    if (formtype === LOCATION) {
      if (isopen && open) {
        return true;
      }
    }

    return false;
  };

  return (
    <div style={{ width: "100%" }} id={`formtype2_${formtype}`} >
      <FormNavHeader
        isopen={isopen && open}
        formtype={formtype}
        display={expressDisplay}
        text={text}
        isFormExpandable={isFormExpandable}
        formid={formid}
        handleOnClick={handleOnHeaderClick}
      ></FormNavHeader>
      {subGroupOpen({ formtype }) ? (
        <FormSubGroupsNav
          formid={formid}
          formtype={formtype}
          groupsorder={groupsorder}
        ></FormSubGroupsNav>
      ) : null}
    </div>
  );
};

export default FormHeaderAndSubGroups;
